module.exports = __webpack_public_path__ + "static/media/No_Projects_List.caa4f98a.png";